import React, { useState } from "react";
import { Error as ErrorMessage, Loading } from "components/panels";
import { ExclusivityConflictsModal } from "./ExclusivityConflictsModal";
import { ExclusivityCheckResultMessage, ExclusivityClauseDetailsForSidePanel } from "./ExclusivityClauseMessages";
import { useExclusivityCheckFields, useExclusivityConflictCount } from "./hooks";
import { ExclusivityCheckFields } from "./utils";

interface Props {
  show: server.dto.Show
  exclusivityCheckFields: ExclusivityCheckFields
}

export const ExclusivityConflictsForShowSidePanel = (props: Props) => {
  const [isExclusivityConflictsModalOpen, setIsExclusivityConflictsModalOpen] = useState(false);
  const exclusivityCheckFields = useExclusivityCheckFields({
    fields: props.exclusivityCheckFields,
    exclusivityClause: props.exclusivityCheckFields.exclusivityClause,
  });
  const { data: result, isLoading, isError } = useExclusivityConflictCount({ exclusivityCheckFields });

  const conflictsModal = <ExclusivityConflictsModal
    isOpen={isExclusivityConflictsModalOpen}
    handleClose={() => setIsExclusivityConflictsModalOpen(false)}
    activeShow={props.show}
    exclusivityCheckFields={exclusivityCheckFields}
  />;

  if (isError) {
    return <>
      {conflictsModal}
      <ErrorMessage />
    </>
  }

  if (isLoading) {
    return <>
      {conflictsModal}
      <Loading />
    </>
  }

  return <>
    {conflictsModal}
    <ExclusivityClauseDetailsForSidePanel
      result={result}
      clause={exclusivityCheckFields.exclusivityClause}
    />
    <ExclusivityCheckResultMessage
      wrapperClassName="exclusivity-message-wrapper-side-panel"
      openExclusivityConflictModal={() => setIsExclusivityConflictsModalOpen(true)}
      result={result}
    />
  </>
}
